<script lang="ts" setup>
import type { EditorialCardProps } from './types'

const { imageDesktop, imageMobile, title, content, shopTheLookTitle, link, externalLink, shopTheLookHandles } =
  defineProps<EditorialCardProps>()

const openShopTheLook = () => {
  if (!shopTheLookHandles?.length) return

  document.dispatchEvent(
    new CustomEvent('shop-the-look:open', {
      detail: {
        handles: shopTheLookHandles,
        title: shopTheLookTitle || 'Shop The Look'
      },
      bubbles: true,
      composed: true
    })
  )
}

const go = () => {
  if (shopTheLookHandles?.length) {
    openShopTheLook()

    return
  }

  if (!link) return
  externalLink ? window.open(link, '_blank') : (window.location.href = link)
}
</script>

<template>
  <article
    role="button"
    :aria-label="title || (shopTheLookHandles?.length ? 'Shop the look' : link ? 'Shop now' : 'Editorial card')"
    class="editorial-card tw-relative tw-cursor-pointer"
    tabindex="0"
    @click="go"
    @keydown.enter.prevent="go"
    @keydown.space.prevent="go"
  >
    <div class="editorial-card__media tw-relative">
      <picture>
        <source v-if="imageMobile" :srcset="imageMobile" media="(max-width: 768px)" />
        <img :src="imageDesktop" :alt="title || ''" loading="lazy" class="tw-w-full" />
      </picture>
      <div
        v-if="shopTheLookHandles?.length"
        class="tw-absolute tw-bottom-0 tw-left-0 tw-w-full tw-px-2.5 tw-py-5 tw-text-center tw-text-white 2lg:tw-p-5"
      >
        <div
          class="editorial-card__cta editorial-card__cta-look tw-inline-flex tw-items-center tw-justify-center tw-gap-1 tw-text-xxs tw-uppercase 2lg:tw-gap-2 2lg:tw-text-xs"
        >
          <svg
            aria-hidden="true"
            fill="none"
            focusable="false"
            width="14"
            class="header__nav-icon icon icon-cart"
            viewBox="0 0 24 24"
          >
            <path
              d="M4.75 8.25A.75.75 0 0 0 4 9L3 19.125c0 1.418 1.207 2.625 2.625 2.625h12.75c1.418 0 2.625-1.149 2.625-2.566L20 9a.75.75 0 0 0-.75-.75H4.75Zm2.75 0v-1.5a4.5 4.5 0 0 1 4.5-4.5v0a4.5 4.5 0 0 1 4.5 4.5v1.5"
              stroke="currentColor"
              stroke-width="1.4"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </svg>
          <span>Shop the look</span>
        </div>
      </div>
    </div>

    <div class="editorial-card__content tw-flex tw-w-full tw-flex-col tw-items-center tw-gap-[0.25rem] tw-text-black">
      <h3 v-if="title" class="tw-text-sm tw-font-bold tw-uppercase">{{ title }}</h3>
      <p v-if="content" class="tw-text-xs">{{ content }}</p>
    </div>
  </article>
</template>
